import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import GroupeSelect from 'components/Shared/GroupeSelect';

const styles = {
    root: {
        margin: '0 10px'
    },
    row: {
        maxWidth: '30%',
        marginBottom: '10px'
    },
    rowCommentaire: {
        marginBottom: '10px',
        marginTop: 16
    },
    heightLabel: {
        height: '30px'
    }
};

class InterneStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece'
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { onNextStepValid, reclamation } = this.props;

        let nextStepValid = reclamation.groupeId !== 0;

        onNextStepValid(nextStepValid);
    }

    handleChange = (event) => {
        const { onChange } = this.props;

        onChange(event, null);
    }

    render() {
        const { classes, reclamation } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.row}>
                    <GroupeSelect
                        onChange={this.handleChange}
                        value={reclamation.groupeId}
                        isRequired
                        all={false}
                    />
                </div>

                <div className={classes.rowCommentaire}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="6"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>
            </div>
        );
    }
}

InterneStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired
};

export default withStyles(styles)(InterneStep);